// ABOUTME: Decides what each field of a loading node-info widget looks like: text lines, an image or a file card.
// ABOUTME: Pure: reads the field codes, the schema types known so far and the widget config.

import type { NodeInfoFieldSkeleton } from '../components/NodeInfoFieldsSkeleton';
import { isNodeInfoSystemField } from './nodeInfoSystemFields';

interface NodeInfoFieldSkeletonsInput {
    displayContentTypes: string[];
    // Content type code → schema type, empty while the schema loads.
    typeMap: Record<string, string>;
    // Whether a schema type is drawn with an icon avatar.
    hasIcon: (type: string | undefined) => boolean;
    showIcon: boolean;
    fileCards: boolean;
    // The widget sets an image style, so its non-file fields are shown as images (a text field
    // holding an image URL included).
    imageStyled: boolean;
}

export function nodeInfoFieldSkeletons({
    displayContentTypes,
    typeMap,
    hasIcon,
    showIcon,
    fileCards,
    imageStyled,
}: NodeInfoFieldSkeletonsInput): NodeInfoFieldSkeleton[] {
    return displayContentTypes.map(code => {
        // A system field is shown without icon; `lastUpdate` reads who, then when.
        if (isNodeInfoSystemField(code, typeMap)) {
            return { key: code, kind: 'lines', lines: code === 'lastUpdate' ? 2 : 1, icon: false };
        }
        const type = typeMap[code];
        // A file card widget shows its files as cards; before the schema lands a field of unknown
        // type is taken as one of them.
        if (fileCards && (type === 'file' || type === 'media' || type === undefined)) {
            return { key: code, kind: 'fileCard' };
        }
        const icon = showIcon && hasIcon(type);
        if (type === 'image' || type === 'media' || (imageStyled && type !== 'file')) {
            return { key: code, kind: 'image', icon };
        }
        return { key: code, kind: 'lines', lines: 1, icon };
    });
}
